import React from 'react';

import { DoctorBookedValues } from '@app/objects/Doctor';
import { daysShort, monthsShort } from '@app/utils/DoctorBookedTimeBlock/DoctorBookedTimeBlock';

interface Props {
	leftChevronDisabled: boolean;
	onSelectPreviousWeek: () => void;
	onSelectNextWeek: () => void;
	columns: DoctorBookedValues;
	disabledButtons?: boolean;
	daysRange?: number;
}

const DoctorBookedTimeBlockHeader: React.FC<Props> = ({
	leftChevronDisabled,
	onSelectNextWeek,
	onSelectPreviousWeek,
	columns,
	disabledButtons,
	daysRange,
}) => {
	return (
		<tr className="table__header">
			<th className="text-primary">
				<button
					className="btn fa fa-chevron-left doctor-booked-time__button"
					title="Previous week"
					type="button"
					disabled={disabledButtons || leftChevronDisabled}
					onClick={onSelectPreviousWeek}
				/>
			</th>
			{Object.keys(columns).slice(0, daysRange).map((day, index) => {
				const [_, year, month, date] = day.match(/(\d\d\d\d)-(\d\d)-(\d\d)/) ?? [];
				return <th
					key={day}
					className="text-primary"
					style={{ padding: '5px' }}
				>
					{daysShort[new Date(+new Date(day) + new Date().getTimezoneOffset() * 60000).getDay()]}
					<br />
					{`${monthsShort[+month - 1]} ${date}`}
				</th>;
			})}
			<th className="text-primary">
				<button
					className="btn fa fa-chevron-right doctor-booked-time__button"
					title="Next week"
					type="button"
					aria-hidden="true"
					disabled={disabledButtons}
					onClick={onSelectNextWeek}
				/>
			</th>
		</tr>
	);
};

export default DoctorBookedTimeBlockHeader;
